export const REQUEST_STAUS = {
    'IS_DROPPED': 'is_dropped',
    'PENDING':'Pending',
    'TICKET_CREATED': 'Ticket Created',
    'FORWARDED_TO_PEG': 'Forwarded to peg',
    'CLOSED_ON_CALL': 'Closed on call',
    'RESOLVED': 'Resolved',
    'ACKNOWLEDGED': 'Acknowledged'
}